// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"560b5c9c","498":"902efed3","513":"c0ad6765","703":"76c879bf"}[chunkId] + ".chunk.js";
};